import React, { useEffect, useMemo } from 'react'
import { Link } from 'react-router-dom'
import { injectReducer } from 'store'
import reducer from './store'
import { useDispatch, useSelector } from 'react-redux'
import { getData, setTableData } from './store/dataSlice'
import { HiOutlinePencil, HiOutlineTrash } from 'react-icons/hi'
import Tooltip from 'components/Ui/Tooltip'
import { ConfirmationModal, Table } from 'components/Ui'
import { deleteApiRecord } from 'services/ExtraChargeService'
import { Success } from 'utils/alerts'
import useAuth from 'utils/hooks/useAuth'
injectReducer('extraCharges', reducer)

export default function ExtraCharges() {
    const dispatch = useDispatch()
    const { checkPermission } = useAuth()
    const { data, tableData, loading } = useSelector(
        (state) => state.extraCharges.data,
    )

    useEffect(() => {
        fetchData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        dispatch,
        tableData.sort,
        tableData.query,
        tableData.pageIndex,
        tableData.pageSize,
        tableData.selectedTab,
        tableData.checkBox,
        tableData.service,
    ])

    const fetchData = () => dispatch(getData({ ...tableData }))

    const handleDelete = (id) => {
        deleteApiRecord(id)
            .then(() => {
                Success('Deleted Successfully!')
                fetchData()
            })
            .catch((error) => error)
    }

    const columns = useMemo(
        () => [
            {
                field: 'company',
                header: 'Company',
                className: 'min-w-[150px]',
                renderCell: (row) => row?.assignment?.company_name,
            },
            {
                field: 'client',
                header: 'Client Company',
                className: 'min-w-[150px]',
                renderCell: (row) => row?.assignment?.client,
            },
            {
                field: 'transport_provider_name',
                header: 'Transport Provider',
                className: 'min-w-[150px]',
                renderCell: (row) => row?.assignment?.transport_provider_name,
            },
            {
                field: 'transport_provider_service',
                header: 'Service',
                className: 'min-w-[150px]',
                renderCell: (row) => row?.assignment?.service_name,
            },
            {
                field: 'fee_code',
                header: 'Fee Code',
                className: 'min-w-[150px]',
            },
            {
                field: 'fee_description',
                header: 'Fee Description',
                className: 'min-w-[150px]',
            },
            {
                field: 'charge_value',
                header: 'Charge Value',
                className: 'min-w-[150px]',
            },
            {
                header: 'Action',
                field: 'action',
                className: 'px-4',
                renderCell: (row) => {
                    return (
                        <div className="flex items-center gap-3">
                            {checkPermission('extra-charges', 'edit') ? (
                                <Tooltip title={'Edit'}>
                                    <Link
                                        to={`/master-data/extra-charges/${row.id}/edit`}
                                        className="hover:text-primary"
                                    >
                                        <HiOutlinePencil size={20} />
                                    </Link>
                                </Tooltip>
                            ) : null}
                            {checkPermission('extra-charges', 'delete') ? (
                                <Tooltip title={'Delete'}>
                                    <ConfirmationModal
                                        message={
                                            'Are you sure you want to delete this record!'
                                        }
                                        onConfirm={() => {
                                            handleDelete(row.id)
                                        }}
                                    >
                                        <span className="hover:text-danger">
                                            <HiOutlineTrash size={20} />
                                        </span>
                                    </ConfirmationModal>
                                </Tooltip>
                            ) : null}
                        </div>
                    )
                },
            },
        ],
        // eslint-disable-next-line
        [
            tableData.sort,
            tableData.query,
            tableData.pageIndex,
            tableData.pageSize,
            tableData.selectedTab,
            tableData.checkBox,
            tableData.service,
        ],
    )

    return (
        <>
            <div className="flex flex-col gap-1 mb-5 sm:flex-row sm:items-center sm:justify-between">
                <h2 className="font-semibold text-black text-title-md2 dark:text-white">
                    Extra Charges
                </h2>
            </div>
            <Table
                loading={loading}
                filter={false}
                servicefilter={true}
                datas={data}
                columns={columns}
                add_new={
                    checkPermission('extra-charges', 'create')
                        ? '/master-data/extra-charges/create'
                        : ''
                }
                pagingData={tableData}
                onChange={(e) => dispatch(setTableData(e))}
            />
        </>
    )
}
